export const REF_NAME = 'PRODUCT';
export const REF_PATH = 'product';
export const NAME = 'Product';
export const SUBTYPE_NAME = 'PRODUCT_SUBTYPE';
export const SUBTYPE_PATH = 'producttype';
